// extracted by mini-css-extract-plugin
module.exports = {"links":"header-menu_links__2AtAA","link":"header-menu_link__1PInI","active":"header-menu_active__jZBr3","linkArrow":"header-menu_linkArrow__dFXEJ","open":"header-menu_open__1nQSA"};